import { render, staticRenderFns } from "./LawyerIndex.vue?vue&type=template&id=6e9c1f1c&scoped=true&"
import script from "./LawyerIndex.vue?vue&type=script&lang=js&"
export * from "./LawyerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c1f1c",
  null
  
)

export default component.exports